<script lang="ts" setup>
import HotMatchItemNews from './hot-match-item-news.vue'
import { hotmatchNoDataItem } from '~/resources/sports'
import { useHotmatches } from '~/composables/home/use-hotmatches'
import { useSwiper } from '~/composables/common/use-swiper'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const { isLighthouseBot } = useLighthouse()
const { hotmatches, isLoadingHotmatch } = useHotmatches()
const { modules } = useSwiper()

defineProps({
  isNews: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
  <div class="sport-hotmatch" :class="{ 'hotmatch-news': isNews }">
    <div class="heading-title">
      <div class="heading-title__left">Trận Đấu Hot</div>
      <NuxtLink class="show-more-btn" to="/the-thao/lich-thi-dau">Xem thêm</NuxtLink>
    </div>
    <div class="position-relative sport-hotmatch__wrapper">
      <Swiper
        v-if="hotmatches?.length"
        :modules="modules"
        :spaceBetween="0"
        loop
        :pagination="{ clickable: true, el: '.swiper-pagination-hotmatch' }"
      >
        <SwiperSlide v-for="(hotmatch, index) in hotmatches" :key="index">
          <HotMatchItemNews :item="hotmatch" />
        </SwiperSlide>
      </Swiper>
      <HotMatchItemNews v-if="!hotmatches?.length && !isLoadingHotmatch" :item="hotmatchNoDataItem" />
      <div v-if="!isLighthouseBot" class="swiper-pagination-hotmatch swiper-pagination"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/mobile/sports/hot-match.scss';
</style>
